import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { Modal } from '../modal.tsx'
import {
  type FormFooterContextProps,
  FormFooterProvider,
} from './form-footer-context.ts'

export type FormModalFooterProps = PropsWithChildren<
  Partial<FormFooterContextProps> & {
    className?: string
  }
>

export const FormModalFooter = ({
  children,
  className,
  orientation = 'vertical',
}: FormModalFooterProps) => {
  return (
    <FormFooterProvider value={{ orientation }}>
      <Modal.Footer
        className={cn(
          'bg-container-tertiary px-8 py-6',
          {
            'flex flex-row gap-6': orientation === 'horizontal',
            'flex flex-col gap-2': orientation === 'vertical',
          },
          className
        )}
      >
        {children}
      </Modal.Footer>
    </FormFooterProvider>
  )
}
